import axios from 'axios'
// 获取充值选项
export const getRechargeList = (data) => {
    return axios({
        url: '/mall/phone/recharge/list/',
        method: 'get',
        params: data
    })
}
// 充值下单
export const rechargeCreateOrder = (data) => {
    return axios({
        url: '/mall/phone/recharge/create/order/',
        method: 'post',
        data:data
    })
}
// 消费记录
export const rechargePayRecord = (data) => {
    return axios({
        url: '/mall/phone/recharge/pay/record/',
        method: 'get',
        params: data
    })
}
// 充值记录
export const rechargeRecord = (data) => {
    return axios({
        url: '/mall/phone/recharge/record/',
        method: 'get',
        params: data
    })
}